import React, { useEffect, useState } from 'react';

interface NotificationProps {
  message: string;
  type?: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
  onClose?: () => void;
  isVisible: boolean;
}

const Notification: React.FC<NotificationProps> = ({
  message,
  type = 'info',
  duration = 3000,
  onClose,
  isVisible
}) => {
  const [isShowing, setIsShowing] = useState(isVisible);

  useEffect(() => {
    setIsShowing(isVisible);
    
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        setIsShowing(false);
        onClose?.();
      }, duration);
      
      return () => clearTimeout(timer);
    }
    
    return undefined;
  }, [isVisible, duration, onClose]);

  if (!isShowing) return null;

  const getTypeStyles = () => {
    switch (type) {
      case 'success':
        return {
          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
          icon: '✅',
          borderColor: '#10b981'
        };
      case 'error':
        return {
          background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
          icon: '❌',
          borderColor: '#ef4444'
        };
      case 'warning':
        return {
          background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
          icon: '⚠️',
          borderColor: '#f59e0b'
        };
      default:
        return {
          background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
          icon: 'ℹ️',
          borderColor: '#3b82f6'
        };
    }
  };

  const styles = getTypeStyles();

  return (
    <div className="mj-notification-overlay">
      <div 
        className="mj-notification"
        style={{
          background: styles.background,
          borderColor: styles.borderColor
        }}
      >
        <div className="mj-notification-content">
          <span className="mj-notification-icon">{styles.icon}</span>
          <span className="mj-notification-message">{message}</span>
        </div>
        <button 
          className="mj-notification-close"
          onClick={() => {
            setIsShowing(false);
            onClose?.();
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Notification; 